export default "__VITE_ASSET__wQrPQCeOvi$zO8dTE6SWlA__"